'use client';

import { useChatStore } from '@/stores/chatStore';
import ChatInterface from '@/components/chat/ChatInterface';
import VerseCard from '@/components/chat/VerseCard';
import { Trash2 } from 'lucide-react';

export default function ChatPage() {
  const { currentSources, clearChat, messages } = useChatStore();

  return (
    <div className="flex h-screen">
      {/* Chat area — 70% */}
      <div className="flex-[7] flex flex-col min-w-0">
        {/* Header */}
        <div
          className="flex items-center justify-between px-6 py-3 shrink-0"
          style={{ borderBottom: '1px solid rgba(200, 164, 94, 0.1)' }}
        >
          <h1
            className="text-lg font-semibold"
            style={{ color: 'var(--text-primary)' }}
          >
            Bible Chat
          </h1>
          {messages.length > 0 && (
            <button
              onClick={clearChat}
              className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg transition-colors hover:bg-white/5"
              style={{ color: 'var(--text-secondary)' }}
            >
              <Trash2 size={14} />
              Clear
            </button>
          )}
        </div>

        <ChatInterface />
      </div>

      {/* Citations sidebar — 30% */}
      <div
        className="flex-[3] flex flex-col min-w-0 overflow-y-auto"
        style={{
          backgroundColor: 'var(--bg-secondary)',
          borderLeft: '1px solid rgba(200, 164, 94, 0.1)',
        }}
      >
        <div
          className="px-4 py-3 shrink-0"
          style={{ borderBottom: '1px solid rgba(200, 164, 94, 0.1)' }}
        >
          <h2
            className="text-sm font-semibold"
            style={{ color: 'var(--text-secondary)' }}
          >
            Citations
          </h2>
        </div>
        <div className="p-4 space-y-3">
          {currentSources.length > 0 ? (
            currentSources.map((verse, i) => (
              <VerseCard key={i} verse={verse} />
            ))
          ) : (
            <p
              className="text-xs text-center py-8 opacity-40"
              style={{ color: 'var(--text-secondary)' }}
            >
              Verse citations will appear here
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
